import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { AppValidators } from 'src/app/common/appValidators';
import { AddOwnerActionDefinitionModel } from 'src/app/models/api/playbooks/actions/addOwnerProperties';
import { TriggerTypes } from 'src/app/models/api/playbooks/triggers/triggerTypes.enum';
import { PlaybooksActionDefinitionInput } from 'src/app/models/componentInputs/playbookActionInput.interface';

@Component({
  selector: 'app-add-owner-action',
  templateUrl: './add-owner-action.component.html',
  styleUrls: ['./add-owner-action.component.scss'],
})
export class AddOwnerActionComponent implements OnInit {
  @Input() public fg: UntypedFormGroup;
  @Input() public playbooksActionInput: PlaybooksActionDefinitionInput;
  @Input() public triggerType: TriggerTypes;
  public hasChange = false;

  private _newAddOwnerActionDefinitionModel?: AddOwnerActionDefinitionModel;

  ngOnInit(): void {
    let email = '';
    if (this.playbooksActionInput.actionDefinitionProperties) {
      this._newAddOwnerActionDefinitionModel = this.playbooksActionInput
        .actionDefinitionProperties as AddOwnerActionDefinitionModel;
      email = this._newAddOwnerActionDefinitionModel.newOwnerUserEmail;
    }

    this.fg.addControl('newOwnerUserEmail', new UntypedFormControl(email, [Validators.required, AppValidators.email]));
  }
}
